import { ALTERAR_MAPA_SELECIONADO_VEICULO } from '../types'

export default function alterarMapaSelecionadoVeiculo (mapa) {
  return {
    type: ALTERAR_MAPA_SELECIONADO_VEICULO,
    payload: mapa
  }
}
